<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5027 5027"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0" d="M2746 591l-380 0 0 -172c0,-215 -168,-419 -383,-419l-666 0c-215,0 -371,204 -371,419l0 172 -434 0c-281,0 -512,243 -512,524l0 3408c0,280 231,504 512,504l2234 0c281,0 507,-224 507,-504l0 -3408c0,-281 -226,-524 -507,-524zm-431 2375l0 0 -587 845c-25,35 -64,66 -103,66 -25,0 -50,-8 -73,-23 -56,-40 -54,-145 19,-218l451 -679 -985 0c-45,0 -87,19 -110,-21 -21,-40 -20,-67 4,-105l584 -916c37,-59 115,-71 174,-34 58,37 48,99 11,158l-451 682 960 0c47,0 94,33 115,74 22,42 18,132 -9,171z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Energy',
};
</script>

<style scoped>
.fil0 {fill:#83C354;fill-rule:nonzero}
</style>
